<po-page-default p-title="Vincular Item de Lote x Local">
  <div class="barcode-wrapper">
    <po-input name="localCode" [(ngModel)]="localCode" p-icon="an an-barcode" p-placeholder="Digite o código do local"
      (keydown.enter)="loadBatchDetails()" (keydown.tab)="loadBatchDetails(); $event.preventDefault()">
    </po-input>

    <button type="button" class="barcode-scan-btn btn-local" (click)="toggleScannerFor('local')"
      title="Ler código com câmera">
      <span class="po-icon po-icon-camera"></span>
    </button>
  </div>

  <div class="clear-btn-container">
    <po-button p-label="Limpar" p-kind="secondary" (p-click)="onClear()">
    </po-button>
  </div>

  <div class="scanner-box" *ngIf="scannerVisible">
    <zxing-scanner [autostart]="true" [device]="selectedDevice" [formats]="formatsEnabled" [tryHarder]="true"
      (scanSuccess)="onBarcodeScanned($event)">
    </zxing-scanner>
  </div>

  <ng-container *ngIf="locationData">
    <po-widget>
      <div class="po-row po-mb-1" style="font-size: 0.85rem;">
        <div class="po-col po-sm-12">
          <label><strong>Local:</strong> {{ locationData.code }}</label>
        </div>
        <div class="po-col po-sm-12" *ngIf="locationData?.sector">
          <label><strong>Setor:</strong> {{ locationData.sector }}</label>
        </div>
        <div class="po-col po-sm-4 po-md-4 po-mt-1">
          <label>
            <strong>Itens:</strong>
            {{ locationData.itemsCount || 0 | number:'1.0-2' }}
            <ng-container *ngIf="locationData.itemMaximumQuantity > 0">
              / {{ locationData.itemMaximumQuantity | number:'1.0-2' }}
            </ng-container>
          </label>

          <div *ngIf="locationData.itemMaximumQuantity > 0">
            <span class="custom-tag"
              [ngClass]="getAvailabilityTag((locationData.itemMaximumQuantity || 0)-(locationData.itemsCount || 0))">
              Disp: {{ (locationData.itemMaximumQuantity || 0)-(locationData.itemsCount || 0) | number:'1.0-2' }}
            </span>
          </div>
        </div>

        <div class="po-col po-sm-4 po-md-4 po-mt-1">
          <label>
            <strong>Qtd:</strong>
            {{ locationData.quantity || 0 | number:'1.0-2' }}
            <ng-container *ngIf="locationData.maximumQuantity > 0">
              / {{ locationData.maximumQuantity | number:'1.0-2' }}
            </ng-container>
          </label>

          <div *ngIf="locationData.maximumQuantity > 0">
            <span class="custom-tag"
              [ngClass]="getAvailabilityTag((locationData.maximumQuantity || 0 ) - (locationData.quantity || 0))">
              Disp: {{ (locationData.maximumQuantity || 0 ) - (locationData.quantity || 0) | number:'1.0-2' }}
            </span>
          </div>
        </div>

        <div class="po-col po-sm-4 po-md-4 po-mt-1">
          <label>
            <strong>Peso:</strong>
            {{ locationData.weight || 0 | number:'1.0-2' }}
            <ng-container *ngIf="locationData.maximumWeight > 0">
              / {{ locationData.maximumWeight | number:'1.0-2' }}
            </ng-container>
          </label>

          <div *ngIf="locationData.maximumWeight > 0">
            <span class="custom-tag"
              [ngClass]="getAvailabilityTag((locationData.maximumWeight || 0)-(locationData.weight || 0))">
              Disp: {{ (locationData.maximumWeight || 0)-(locationData.weight || 0) | number:'1.0-2' }}
            </span>
          </div>
        </div>

      </div>
    </po-widget>

    <hr class="hr-divider" />

    <div class="barcode-wrapper">
      <po-input #itemBarcodeInput name="itemBarcode" p-label="Código de Barras do Item" p-icon="an an-barcode"
        [(ngModel)]="itemBarcode" p-placeholder="Digite ou escaneie a barra" (keydown.enter)="onAddItem()">
      </po-input>

      <button type="button" class="barcode-scan-btn btn-item" (click)="toggleScannerFor('item')"
        title="Ler código com câmera">
        <span class="po-icon po-icon-camera"></span>
      </button>
    </div>

    <hr class="hr-divider" />

    <div class="scroll-wrapper">
      <div class="scroll-area">
        <div *ngFor="let item of locatedItems">
          <div class="po-row po-mb-2 po-align-items-center item-card">
            <div class="po-xs-10 po-sm-10 po-md-10 item-content">
              <div class="info-line"><strong>Lote:</strong> {{ item.batch }} <strong> Item:</strong> {{item.sequence}}
              </div>
              <div class="info-line"><strong>Produto:</strong> {{ item.item }}</div>
              <div class="info-line"><strong>Barra:</strong> {{ item.barcode }}</div>
              <div class="info-line"><strong>Quantidade:</strong> {{ item.quantity || 0 | number:'1.0-2' }}</div>
            </div>
            <div class="po-xs-2 po-sm-2 po-md-2">
              <po-button p-icon="an an-x-circle" p-danger="true" p-size="large" p-kind="tertiary"
                (p-click)="confirmDeleteItem(item.barcode)" class="icon-button">
              </po-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</po-page-default>
<app-toaster></app-toaster>